import { RuntimeConfig } from '@/infra/env/getEnv'
import { datadogLogs } from '@datadog/browser-logs'
import { UserSession } from '@/domains/auth/AuthenticationPort'

export const initializeDatadogLogs = (runtimeConfig: RuntimeConfig) => {
  datadogLogs.init({
    clientToken: runtimeConfig.DATADOG_CLIENT_TOKEN,
    env: runtimeConfig.ENVIRONMENT,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    service: 'instore-fcs-front',
    sessionSampleRate: 100,
    beforeSend: (log) => {
      if (log.origin === 'network' && log.message.includes('amplitude.com')) {
        return false
      }

      if (/amplitude/i.test(log.message) && !log.message.startsWith('[Amplitude]')) {
        log.message = `[Amplitude] ${log.message}`
      }

      return true
    },
  })
}

export const setUserForDatadogLogs = (userSession: UserSession) => {
  datadogLogs.setUser({
    name: userSession.name,
    email: userSession.email,
    id: userSession.id,
  })
}
